import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiRadio, FiZap } = FiIcons;

export default function NFCModal({ scene, onClose, onSave }) {
  const [formData, setFormData] = useState({
    name: '',
    tagId: '',
    action: 'toggle_light',
    description: ''
  });

  useEffect(() => {
    if (scene) setFormData(scene);
  }, [scene]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-30" onClick={onClose} />
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }} 
          animate={{ opacity: 1, scale: 1 }}
          className="relative bg-white rounded-xl shadow-xl max-w-md w-full p-6"
        >
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-900">
              {scene ? 'Szene bearbeiten' : 'Neuer NFC Tag'}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
              <input
                type="text"
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                placeholder="z.B. Küche Licht"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tag ID / Kennung</label>
              <div className="relative">
                 <SafeIcon icon={FiRadio} className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  value={formData.tagId}
                  onChange={e => setFormData({ ...formData, tagId: e.target.value })}
                  className="w-full pl-10 border border-gray-300 rounded-lg px-3 py-2"
                  placeholder="Scannt..."
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Aktion</label>
              <div className="relative">
                <SafeIcon icon={FiZap} className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                <select
                  value={formData.action}
                  onChange={e => setFormData({ ...formData, action: e.target.value })}
                  className="w-full pl-10 border border-gray-300 rounded-lg px-3 py-2"
                >
                  <option value="toggle_light">Licht umschalten</option>
                  <option value="play_music">Musik starten</option>
                  <option value="shopping_add">Auf Einkaufsliste setzen</option>
                  <option value="timer_5min">Timer 5 Min</option>
                  <option value="wifi_guest">Gäste-WLAN anzeigen</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button type="button" onClick={onClose} className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg">
                Abbrechen
              </button>
              <button type="submit" className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700">
                Speichern
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}